import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { Observable } from 'rxjs';
import { DarkSkyResult } from './weather.models';

@Injectable()
export class WeatherService
{
	// constructor
	constructor
		(
			private http: HttpClient,
			private router: Router,
			@Inject('BASE_URL') private baseUrl: string
		)
	{

	}

	// get current forecast
	public getCurrentForecast(latitude: number, longitude: number)
	{
		const urlParts = this.router.url.split('/');
		const area = urlParts[1] || null;
		const controller = urlParts[2] || null;

		// decoding token payload
		const httpOptions =
		{
			params: new HttpParams().set('CurrentArea', area).set('CurrentController', controller)
		};

		return this.http.get<DarkSkyResult>(`${this.baseUrl}api/shared/shared/localWeather/${latitude}/${longitude}`, httpOptions);
	}
}